import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative ratio-international-image text-amff-white" }
const _hoisted_2 = {
  class: "absolute bottom-0 inset-x-0 text-center px-container font-display",
  style: {"padding-bottom":"8%"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("div", { class: "\n            text-lg\n            sm:text-xl\n            md:text-2xl\n            lg:text-4xl\n            tracking-widest\n            lg:tracking-ultra\n          " }, " International "),
  /*#__PURE__*/_createVNode("div", { class: "mt-3 text-2xl sm:text-3xl md:text-5xl lg:mt-4 lg:text-6xl" }, " Atlàntida Mallorca Film Fest ")
], -1)
const _hoisted_4 = { class: "mt-3 text-lg sm:text-xl md:text-2xl lg:mt-4 lg:text-3xl" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_PostsBlock = _resolveComponent("PostsBlock")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: `${_ctx.baseURL}img/international/international.jpg`,
        srcset: `
        ${_ctx.baseURL}img/international/international.jpg    1440w,
        ${_ctx.baseURL}img/international/international@2x.jpg 2880w,
        ${_ctx.baseURL}img/international/international@3x.jpg    4320w
      `,
        class: "absolute inset-0 w-full h-full object-cover",
        style: {
        objectPosition: !_ctx.isMobile ? '' : `${_ctx.backgroundPosition}%`,
      }
      }, null, 12, ["src", "srcset"]),
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("international.countries")), 1)
      ])
    ]),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("international.title")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_PageContent, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("international.content")) + " ", 1),
            _createVNode("a", {
              class: "font-bold",
              href: `${_ctx.baseURL}pdf/amff-international.pdf`,
              target: "_blank"
            }, _toDisplayString(_ctx.$t("international.here")), 9, ["href"]),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_PostsBlock),
    _createVNode(_component_FollowFestival)
  ], 64))
}